<template>
  <section class="section pricing-tariffs-features" v-if="!mediaLgMatches">
    <div class="container">
      <header class="section__header pricing-tariffs-features__header">
        <h2 v-html="translations.title" />
        <tabs
          :tabs="[
            { label: translations.tabs.professional, labelShort: translations.tabs.pro },
            { label: translations.tabs.maximum, labelShort: translations.tabs.max },
            { label: translations.tabs.enterprise },
          ]"
          :tabs-class="'pricing-tariffs-features__tabs'"
          :current-tab="this.current"
          @tab="handleTab"
        ></tabs>
      </header>
    </div>
    <pricing-tariffs-features-sliders :current="current" @handleTab="handleTab"></pricing-tariffs-features-sliders>
  </section>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import translations from './pricing-translations';
import Tabs from '~scripts/components/vue/Tabs.vue';
import PricingTariffsFeaturesSliders from './PricingTariffsFeaturesSliders.vue';

export default {
  name: 'PricingTariffsFeatures',
  components: { Tabs, PricingTariffsFeaturesSliders },
  data() {
    return {
      mediaLgMatches: false,
      current: 0,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    region() {
      return window.region;
    },
    lang() {
      return this.region === 'ai' ? 'en' : 'ru';
    },
    translations() {
      return translations[this.lang];
    },
    mediaLg() {
      return window.matchMedia(`(min-width: ${this.breakpoints.lgMin})`);
    },
  },
  mounted() {
    this.handleMediaLgMatchesChange();
    this.mediaLg.addEventListener('change', this.handleMediaLgMatchesChange, { passive: true });
  },
  beforeDestroy() {
    this.mediaLg.removeEventListener('change', this.handleMediaLgMatchesChange);
  },
  methods: {
    handleMediaLgMatchesChange() {
      this.mediaLgMatches = this.mediaLg.matches;
    },
    handleTab(current) {
      this.current = current;
    },
  },
};
</script>
